import { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import useImageWrapper from "helpers/hooks/useImageWrapper";
import { fromPricing } from "helpers/formatting";
import { Media } from "solar/components/Media";
import Button from "solar/components/Button";
import ButtonImage from "solar/components/ButtonImage";
import Photo from "components/shared/stays/Photo";
import Truncate from "solar/components/Truncate";
import styles from "components/stay/AvailabilityFlexibleProduct.module.scss";

export default function AvailabilityFlexibleProduct({
  id,
  name,
  price,
  pricingType,
  description,
  images,
  status,
  handleProductsModalOpen,
}) {
  const { getImageWidth } = useImageWrapper();
  const [imgWidths, setImgWidths] = useState([0]);
  const imgWrapperRef = useRef(null);

  useEffect(() => {
    const calculatedWidth = getImageWidth([imgWrapperRef]);
    setImgWidths(calculatedWidth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div
      className={cn(styles.product, !status.available && styles.unavailable)}
    >
      <div className={styles.visual} ref={imgWrapperRef}>
        {images.length > 0 && (
          <ButtonImage onClick={() => handleProductsModalOpen(id)}>
            <Photo
              src={images[0].file.url}
              alt={name}
              layout="fill"
              objectFit="cover"
              placeholder
              containerWidth={imgWidths[0]}
            />
          </ButtonImage>
        )}
      </div>
      <div className={styles.text}>
        <Button
          link
          onClick={() => handleProductsModalOpen(id)}
          className={styles.name}
        >
          <Truncate clamp={1}>{name}</Truncate>
        </Button>
        <div className={styles.description}>
          <Media lessThan="lg">
            <Truncate
              chars={40}
              more
              moreText="more"
              moreModal={() => handleProductsModalOpen(id)}
            >
              {description}
            </Truncate>
          </Media>
          <Media greaterThan="md">
            <Truncate
              chars={65}
              more
              moreText="more"
              moreModal={() => handleProductsModalOpen(id)}
            >
              {description}
            </Truncate>
          </Media>
        </div>
        <div className={styles.price}>{fromPricing(price, pricingType)}</div>
      </div>
      <div className={styles.actions}>
        <div className={styles.status}>{status.text}</div>
        <div className={styles.cta}>{status.action}</div>
      </div>
    </div>
  );
}

AvailabilityFlexibleProduct.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  pricingType: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.shape({
        url: PropTypes.string,
      }),
    })
  ).isRequired,
  status: PropTypes.shape({
    available: PropTypes.bool,
    text: PropTypes.string,
    action: PropTypes.node,
  }).isRequired,
  handleProductsModalOpen: PropTypes.func.isRequired,
};
